/*
--------------------------------------------------------------------------------------------------------------
Autor:              EMANUEL GUIVAR
Fecha de creacion:  09/04/2025
Sistema:            Web seguros
Descripcion:        hook para manejo de inputs de efectiva - seguros
BITACORA DE CAMBIOS 
--------------------------------------------------------------------------------------------------------------
CODIGO      REQ     ANALISTA                    FECHA       MOTIVO
(@#)1-A   SOL 32929    Emanuel Guivar           01/08/2025   Cambios fase 2 - Seguros
(@#)2-A   SOL 33756    Emanuel Guivar           30/12/2025   Cambios fase 3 - Seguros desailiacion, siniestro y endosos
(@#)2-B   SOL 33756    Emanuel Guivar           24/01/2026   Cambios fase 3 - Seguros desailiacion, siniestro y endosos
--------------------------------------------------------------------------------------------------------------
*/
//import { useEffect, useState } from "react"; //(@#)1-A
import { useEffect, useState, useRef } from "react";  //(@#)1-A
import FinancieraAPI from "../data/FinancieraAPI";
import { Messages } from "../data/FinancieraData";
import Helpers from "../data/Helpers";
import useUrlQuery from "./useUrlQuery";

//definir el tipo antes de los estados o funciones
type SeguroAsociado = {
    prestamo: string;
    seguro: string;
    cobertura?: string;
    medioDevo?: string; //(@#)1-A
    nroCuenta?: string; //(@#)1-A
};

// inputs por defecto
const initialInputs = {
    appOrig: '',        // aplicacion origen
    // datos personales
    tipoDocSol: 'DNI',     // tipo de documento solicitante
    numDocSol: '',         // numero de documento
    apPaternoSol: '',      // apellido paterno
    apMaternoSol: '',      // apellido materno
    nombresSol: '',        // nombres
    tipoDocTit: 'DNI',     // tipo de documento titular
    numDocTit: '',         // numero de documento
    apPaternoTit: '',      // apellido paterno
    apMaternoTit: '',      // apellido materno
    nombresTit: '',        // nombres
    direccion: '',      // direccion
    direccionNro: '',   // direcccion nro / mz
    direccionLot: '',   // direccion lote
    direccionInt: '',   // direccion Int / Dpto
    urbanizacion: '',   // urbaniacion
    departamento: '',   // departamento
    provincia: '',      // provincia
    distrito: '',       // distrito
    telefono: '',       // nro telefono
    correo: '',         // correo electronico
    tipoSol: '',        // tipo de solicitud
    motivoSol: '',   // motivo de solicitud
    //(@#)2-A inicio
    detalleMotivoSol: '', // detalle del motivo para desafiliacion "Otros"
    agencia: '',  // agencia
    local: '',  // local
    direccionLoc: '', // direccion del local
    //(@#)2-A fin
    medioResp: 'Correo electronico', // medio de respuesta
    // Datos del Reclamo
    prestamo: '',     // prestamos 
    seguro: '',     // seguro
    cobertura: '',   //cobertura
    medioDevo: '',  //medio devolucion  //(@#)1-A
    nroCuenta: '',   //numero de cuenta efectiva  //(@#)1-A
    // Voluntad del Cliente
    detalle: '',        // detalle del reclamo
    solucion: '',        // solucion esperada //(@#)2-A
    origenUser: '',     // Origen usuario //(@#)2-A
};
const names = Helpers.asignarNombres(initialInputs);            // nombres de los inputs
const defaultErrors = Helpers.asignarErrores(initialInputs);    // obj de errores por defecto

//const useFinancieraLogic = () => {  //(@#)2-A 
const useFinancieraLogic = (appUser: string) => {  //(@#)2-A 

    // inputs default
    const defaultInputs = {
        ...initialInputs,
        //(@#)2-A inicio
        //appOrig: useUrlQuery().get("app")||'WebSeguros', 
        appOrig: useUrlQuery().get("app") || 'Web Efectiva',
        origenUser: appUser,
        //(@#)2-A fin
    }

    // crear estado para inputs
    const [inputs, setInputs] = useState(defaultInputs);
    // crear estado para errores
    const [errors, setErrors] = useState(defaultErrors);
    // crear estado para resultado del registro
    const [result, setResult] = useState<ApiResponse>({procesing:false, response:null});

    // estados de options para inputselects
    const [documentos, setDocumentos] = useState<InputSelectData>([]);
    const [solicitudes, setSolicitudes] = useState<InputSelectData>([]);
    const [creditos, setCreditos] = useState<InputSelectData>([]);
    const [seguros, setSeguros] = useState<InputSelectData>([]);
    const [coberturas, setCoberturas] = useState<InputSelectData>([]);
    const [segurosSeleccionados, setSegurosSeleccionados] = useState<SeguroAsociado[]>([]);
    const [coberturasCargadas, setCoberturasCargadas] = useState(false);
    //const [archivos, setArchivos] = useState([]);  //(@#)2-A
    const [departamentos, setDepartamentos] = useState<InputSelectData>([]); 
    const [provincias, setProvincias] = useState<InputSelectData>([]); 
    const [distritos, setDistritos] = useState<InputSelectData>([]); 
    const [mediosDevo, setMediosDevo] = useState<InputSelectData>([]); //(@#)1-A
    const [respuesta, setRespuesta] = useState<InputSelectData>([]); //(@#)1-A
    const tipoSolCambiadoRef = useRef(false); //(@#)1-A
    //(@#)2-A inicio
    const [archivos, setArchivos] = useState<File[]>([]); 
    const [motivos, setMotivos] = useState<InputSelectData>([]);  
    const [locales, setLocales] = useState<InputSelectData>([]);
    const [pesoMB, setPesoMB] = useState<number | null>(null); // null mientras carga

    /*
    const subirArchivos = (e: any): void => {
        setArchivos(e);
    };
    */
    const subirArchivos = (files: FileList | null) => {
        if (!files) return;

        const nuevos = Array.prototype.slice.call(files);
        const soloPDF = nuevos.filter(file => file.type === "application/pdf");

        if (soloPDF.length !== nuevos.length) {
            setResult({
                procesing: false,
                response: { isok: false, mensaje: 'Solo se permite archivos en formato PDF' }
            });
            return;
        }

        //(@#)2-B inicio
        if (pesoMB == null) {
            setResult({
                procesing: false,
                response: { isok: false, mensaje: 'No se pudo obtener el peso maximo (MB) permitido para los archivos PDF' }
            });
            return;
        }

        const MAX_TOTAL_SIZE = pesoMB * 1024 * 1024; // 15,728,640 bytes

        // Calcular tamaño total (archivos actuales + nuevos)
        setArchivos(prev => {
            const archivosUnicos = soloPDF.filter(nuevo =>
                !prev.some(existe =>
                    existe.name === nuevo.name &&
                    existe.lastModified === nuevo.lastModified &&
                    existe.size === nuevo.size
                )
            );

            const pesoActual = prev.reduce((acc, file) => acc + file.size, 0);
            const pesoNuevo = archivosUnicos.reduce((acc, file) => acc + file.size, 0);

            if (pesoActual + pesoNuevo > MAX_TOTAL_SIZE) {
                setResult({
                    procesing: false,
                    response: {
                        isok: false,
                        mensaje: `El tamaño total de los archivos PDF no debe superar los ${pesoMB} MB`
                    }
                });
                return prev; //no agrega nada
            }

            return [...prev, ...archivosUnicos];
        });

        /*
        const MAX_SIZE = (pesoMB ?? 15) * 1024 * 1024; // 15,728,640 bytes
        const archivosValidos = soloPDF.filter(file => file.size <= MAX_SIZE);
        const archivosInvalidos = soloPDF.filter(file => file.size > MAX_SIZE);

        if (archivosInvalidos.length > 0) {
            const nombres = archivosInvalidos.map(f => `• ${acortarNombre(f.name, 33)}`).join('\n');

            setResult({
                procesing: false,
                response: {
                    isok: false,
                    mensaje:
                        `Lo(s) siguiente(s) archivo(s) superan el tamaño máximo permitido (${pesoMB} MB):\n${nombres}`
                }
            });
            return;
        }

        setArchivos(prev => {
            const filtrados = archivosValidos.filter(nuevo =>
                !prev.some(existe =>
                    existe.name === nuevo.name &&
                    existe.lastModified === nuevo.lastModified &&
                    existe.size === nuevo.size
                )
            );

            return [...prev, ...filtrados];
        });
        */
        //(@#)2-B fin
    };

    const eliminarArchivo = (index: number) => {
        setArchivos(prev => prev.filter((_, i) => i !== index));
    };

    function acortarNombre(nombre: string, maxLen = 30) {
        if (nombre.length <= maxLen) return nombre;

        const extIndex = nombre.lastIndexOf('.');
        const ext = extIndex !== -1 ? nombre.slice(extIndex) : '';

        // calcular cuántos chars dejar para inicio y fin
        const totalDisponible = maxLen - ext.length - 3; // 3 por "..."
        const charsInicio = Math.ceil(totalDisponible / 2);
        const charsFin = Math.floor(totalDisponible / 2);

        const inicio = nombre.slice(0, charsInicio);
        const fin = nombre.slice(nombre.length - charsFin);

        return `${inicio}...${fin}${ext}`;
    }
    //(@#)2-A fin

    // controlar cambio en inputs
    const handleChange = (name:string, value:string): void => {
        if (result.procesing||result.response) return;
        setInputs({...inputs, [name] : value});
    };

    // controlar salida de inputs
    const handleBlur = (name:string):void => {
        setErrors({...errors, [name] : ''});
    };

 
    // manejar cambio en el select de seguros
    const handleSeguroChange = (name: string, value: string): void => {
        //(@#)1-A Inicio
        if (tipoSolCambiadoRef.current) {
            tipoSolCambiadoRef.current = false; //Resetea la bandera
            return; 
        }
        //(@#)1-A Fin

        if (value === "") return;

        //(@#)1-A Inicio
        //if (!inputs.medioDevo) { //(@#)2-A 
        if (!inputs.medioDevo && inputs.tipoSol === "Desafiliacion de seguros") { //(@#)2-A 
            setResult({
                procesing: false,
                response: { isok: false, mensaje: 'Debe seleccionar un medio de devolucion antes de continuar.' }
            });
            return;
        }

        // Validar número de cuenta si corresponde
        if (inputs.medioDevo === 'Devolucion a traves de una cuenta de ahorros de Efectiva') {
            const nroCuentaVal = inputs.nroCuenta.trim();

            if (!nroCuentaVal) {
                setResult({
                    procesing: false,
                    response: { isok: false, mensaje: 'Debe ingresar una cuenta de ahorros.' }
                });
                return;
            }

            if (!/^\d+$/.test(nroCuentaVal)) {
                setResult({
                    procesing: false,
                    response: { isok: false, mensaje: 'El numero de cuenta solo debe contener digitos.' }
                });
                return;
            }
        }
        //(@#)1-A Fin

        handleChange(name, value);

        if (inputs.tipoSol !== "Aplicacion de siniestros") {  
            const nuevoSeguro: SeguroAsociado = {
                prestamo: inputs.prestamo,
                medioDevo: inputs.medioDevo, //(@#)1-A
                nroCuenta: inputs.nroCuenta,  //(@#)1-A
                seguro: value
            };

            if (inputs.tipoSol === "Desafiliacion de seguros") { //(@#)2-A            
            //(@#)1-A inicio
            // Verificar si ya hay un medio de devolución distinto para este préstamo
            const conflicto = segurosSeleccionados.some(
                s => s.prestamo === nuevoSeguro.prestamo && s.medioDevo && s.medioDevo !== nuevoSeguro.medioDevo
            );

            if (conflicto) {
                setResult({
                    procesing: false,
                    response: { isok: false, mensaje: 'Ya se ha seleccionado un medio de devolucion diferente para este prestamo.' }
                });

                // Limpiar selects
                setInputs(prev => ({
                    ...prev,
                    seguro: '',
                    cobertura: ''
                }));

                return;
            }
                //(@#)1-A fin
            } //(@#)2-A

            // Ya existe ese seguro + préstamo
            const yaExiste = segurosSeleccionados.some(
                s => s.prestamo === nuevoSeguro.prestamo && s.seguro === nuevoSeguro.seguro
            );

            //(@#)1-A Inicio
            //if (yaExiste) return; 
            if (yaExiste) {
                setInputs(prev => ({
                    ...prev,
                    seguro: '',
                    cobertura: ''
                }));
                return;
            }
            //(@#)1-A Fin
        
            setSegurosSeleccionados([...segurosSeleccionados, nuevoSeguro]);
            setInputs(prev => ({
                ...prev,
                seguro: '',
                cobertura: ''
            }));
        } 
    };

    const handleCoberturaChange = (name: string, value: string): void => {
        //(@#)1-A Inicio
        if (tipoSolCambiadoRef.current) {
            tipoSolCambiadoRef.current = false; //Resetea la bandera
            return;
        }
        //(@#)1-A Fin

        if (value === "") return;

        //(@#)1-A Inicio
        //if (!inputs.medioDevo) { //(@#)2-A 
        if (!inputs.medioDevo && inputs.tipoSol === "Desafiliacion de seguros") { //(@#)2-A 
            setResult({
                procesing: false,
                response: { isok: false, mensaje: 'Debe seleccionar un medio de devolucion antes de continuar.' }
            });
            return;
        }
        // Validar número de cuenta si corresponde
        if (inputs.medioDevo === 'Devolucion a traves de una cuenta de ahorros de Efectiva') {
            const nroCuentaVal = inputs.nroCuenta.trim();

            if (!nroCuentaVal) {
                setResult({
                    procesing: false,
                    response: { isok: false, mensaje: 'Debe ingresar una cuenta de ahorros.' }
                });
                return;
            }

            if (!/^\d+$/.test(nroCuentaVal)) {
                setResult({
                    procesing: false,
                    response: { isok: false, mensaje: 'El numero de cuenta solo debe contener digitos.' }
                });
                return;
            }
        }
        //(@#)1-A Fin

        handleChange(name, value);

        if (inputs.tipoSol === "Aplicacion de siniestros") {
            const nuevoSeguro: SeguroAsociado = {
                prestamo: inputs.prestamo,
                seguro: inputs.seguro,
                //medioDevo: inputs.medioDevo,   //(@#)1-A  //(@#)2-A 
                nroCuenta: inputs.nroCuenta,  //(@#)1-A
                cobertura: value
            };

            //(@#)2-A inicio
            //(@#)1-A inicio
            /*
            const conflicto = segurosSeleccionados.some(
                s => s.prestamo === nuevoSeguro.prestamo && s.medioDevo && s.medioDevo !== nuevoSeguro.medioDevo
            );

            if (conflicto) {
                setResult({
                    procesing: false,
                    response: { isok: false, mensaje: 'Ya se ha seleccionado un medio de devolucion diferente para este prestamo.' }
                });

                // Limpiar selects
                setInputs(prev => ({
                    ...prev,
                    seguro: '',
                    cobertura: ''
                }));

                return;
            }
            */
            //(@#)1-A fin
            //(@#)2-A fin

            //Validar si ya existe este seguro + préstamo, sin importar cobertura
            const yaExisteConOtraCobertura = segurosSeleccionados.some(
                s => s.prestamo === nuevoSeguro.prestamo && s.seguro === nuevoSeguro.seguro
            );

            if (yaExisteConOtraCobertura) {
                setResult({
                    procesing: false,
                    response: { isok: false, mensaje: 'Este seguro ya fue escogido con una cobertura.' }
                });
                setInputs(prev => ({
                    ...prev,
                    seguro: '',
                    cobertura: ''
                })); 
                return;
            }
            
            setSegurosSeleccionados([...segurosSeleccionados, nuevoSeguro]);

            setInputs(prev => ({
                ...prev,
                seguro: '',
                cobertura: ''
            }));            
        }
    };

    // Eliminar seguro
    const handleEliminarSeguro = (seguro: SeguroAsociado) => {
        const nuevos = segurosSeleccionados.filter(s => {
            if (inputs.tipoSol === "Aplicacion de siniestros") {
                return !(s.prestamo === seguro.prestamo && s.seguro === seguro.seguro && s.cobertura === seguro.cobertura);
            } else {
                return !(s.prestamo === seguro.prestamo && s.seguro === seguro.seguro);
            }
        });
        setSegurosSeleccionados(nuevos);
    };

    useEffect(() => {
        //(@#)1-A Inicio
        if (tipoSolCambiadoRef.current) {
            tipoSolCambiadoRef.current = false; //Resetea la bandera
            return;
        }
        //(@#)1-A Fin

        if (
            coberturasCargadas &&
            inputs.tipoSol === "Aplicacion de siniestros" &&
            inputs.seguro &&
            coberturas.length === 0
        ) {
            //(@#)1-A Inicio
            //(@#)2-A inicio
            /*
            if (!inputs.medioDevo) {
                setResult({
                    procesing: false,
                    response: { isok: false, mensaje: 'Debe seleccionar un medio de devolucion antes de continuar.' }
                });
                return;
            }
            */
            //(@#)2-A fin

            // Validar número de cuenta si corresponde
            if (inputs.medioDevo === 'Devolucion a traves de una cuenta de ahorros de Efectiva') {
                const nroCuentaVal = inputs.nroCuenta.trim();

                if (!nroCuentaVal) {
                    setResult({
                        procesing: false,
                        response: { isok: false, mensaje: 'Debe ingresar una cuenta de ahorros.' }
                    });
                    return;
                }

                if (!/^\d+$/.test(nroCuentaVal)) {
                    setResult({
                        procesing: false,
                        response: { isok: false, mensaje: 'El numero de cuenta solo debe contener digitos.' }
                    });
                    return;
                }
            }
            //(@#)1-A Fin

            const nuevoSeguro: SeguroAsociado = {
                prestamo: inputs.prestamo,
                seguro: inputs.seguro,
                cobertura: 'No aplica',
                //medioDevo: inputs.medioDevo,  //(@#)1-A //(@#)2-A
                nroCuenta: inputs.nroCuenta   //(@#)1-A
            };

            //(@#)2-A inicio
            /*
            //(@#)1-A inicio
            const conflicto = segurosSeleccionados.some(
                s => s.prestamo === nuevoSeguro.prestamo &&
                    s.medioDevo &&
                    s.medioDevo !== nuevoSeguro.medioDevo
            );

            if (conflicto) {
                setResult({
                    procesing: false,
                    response: { isok: false, mensaje: 'Ya se ha seleccionado un medio de devolucion diferente para este prestamo.' }
                });

                // Limpiar selects
                setInputs(prev => ({
                    ...prev,
                    seguro: '',
                    cobertura: ''
                }));

                return;
            }
            //(@#)1-A fin
            */
            //(@#)2-A fin

            const yaExiste = segurosSeleccionados.some(
                s => s.prestamo === nuevoSeguro.prestamo && s.seguro === nuevoSeguro.seguro
            );

            if (!yaExiste) {
                setSegurosSeleccionados([...segurosSeleccionados, nuevoSeguro]);
            }

            // Limpiar selects
            setInputs(prev => ({
                ...prev,
                seguro: '',
                cobertura: ''
            }));
        }
    }, [coberturasCargadas]);

   
    // logica para tipos documentos
    useEffect(() => {
        const req = FinancieraAPI.getDocumentosReq();
        (async () => {
            try {
                const res = await req.response;
                setDocumentos(Array.isArray(res.data) ? res.data : []);
            } catch (err) {
                setResult({ procesing: false, response: { isok: false, mensaje: Messages.DocumentosError } });
            }
        })();
        return req.cancel;
    }, []);

    // logica para tipos solicitudes
    useEffect(() => {
        const req = FinancieraAPI.getSolicitudesReq();
        (async () => {
            try {
                const res = await req.response;
                setSolicitudes(Array.isArray(res.data) ? res.data : []);
            } catch (err) {
                setResult({ procesing: false, response: { isok: false, mensaje: Messages.SolicitudesError } });
            }
        })();
        return req.cancel;
    }, []);

    //(@#)2-A inicio
    /*
    // logica para mostrar el motivo de solicitud
    useEffect(() => {
        // Limpiar los seguros seleccionados, seguros, coberturas y prestamos
        //(@#)1-A Inicio
        //setSegurosSeleccionados([]);
        //setSeguros([]);
        //setCoberturas([]);
        resetearSegurosYRelacionados();
        tipoSolCambiadoRef.current = true;  
        //(@#)1-A Fin

        // Asegurarse de que los valores de los combos vuelvan a su opción por defecto
        setInputs(prev => {
            const motivo = prev.tipoSol.trim() || '';
           
            return {
                ...prev,
                seguro: '',
                cobertura: '',
                prestamo: '', //(@#)1-A
                medioDevo: '',  //(@#)1-A
                nroCuenta: '', //(@#)1-A
                motivoSol: motivo
            };          
        });
    }, [inputs.tipoSol]);
    */
    
    // logica para mostrar el motivo de solicitud
    useEffect(() => {
        setMotivos([]); //(@#)2-A
        resetearSegurosYRelacionados();
        tipoSolCambiadoRef.current = true;  

        // Asegurarse de que los valores de los combos vuelvan a su opción por defecto
        setInputs(prev => ({
            ...prev,
            seguro: '',
            cobertura: '',
            prestamo: '',
            medioDevo: '',
            nroCuenta: '',
            detalleMotivoSol: '', //(@#)2-A
            motivoSol: ''
        }));

        if (inputs.tipoSol === "Desafiliacion de seguros") {
            const req = FinancieraAPI.getMotivosDesafiliacion();
            (async () => {
                try {
                    const res = await req.response;
                    setMotivos(Array.isArray(res.data) ? res.data : []);
                } catch (err) {
                    setResult({ procesing: false, response: { isok: false, mensaje: Messages.MotivosError } });
                }
            })();
            return req.cancel;
        }        
    }, [inputs.tipoSol]);

    // logica para combo de locales
    useEffect(() => {
        setInputs(prev => ({
            ...prev,
            local: '',
            direccionLoc: ''
        }));

        if (inputs.medioResp === 'Recojo en tienda') {
            const req = FinancieraAPI.GetLocalesReq();
            (async () => {
                try {
                    const res = await req.response;
                    setLocales(Array.isArray(res.data) ? res.data : []);
                } catch (err) {
                    setResult({ procesing: false, response: { isok: false, mensaje: Messages.LocalesError } });
                }
            })();
            return req.cancel;
        }        
    }, [inputs.medioResp]);
        
    // logica para campo de direccion local
    useEffect(() => {
        setInputs(prev => ({...prev, direccionLoc: ''}));
        if (inputs.local !== '') {
            const req = FinancieraAPI.GetDireccionReq(inputs.local);
            (async () => {
                try {
                    const res = await req.response;
                    setInputs(prev => ({ ...prev, direccionLoc: res.data[0].text }));
                } catch (err) {
                    setResult({ procesing: false, response: { isok: false, mensaje: Messages.DireccionError } });
                }
            })();
            return req.cancel;
        }
    }, [inputs.local]);

    // logica para limpiar el detalle motivo desafiliacion "Otros"
    useEffect(() => {
        if (inputs.motivoSol !== 'Otros') {
            setInputs(prev => ({
                ...prev,
                detalleMotivoSol: ''
            }));
        }
    }, [inputs.motivoSol]);

    // logica para obtener el dato parametrizado de BD
    useEffect(() => {
        const req = FinancieraAPI.getPesoArchivoReq();
        (async () => {
            try {
                const res = await req.response;
                setPesoMB(res);
            } catch (err) {
                setResult({ procesing: false, response: { isok: false, mensaje: Messages.PesoArchivoError } });
            }
        })();
        return req.cancel;
    }, []);
    //(@#)2-A fin


    //(@#)1-A Inicio
    // logica para limpiar el nro cta
    useEffect(() => {
        if (inputs.medioDevo !== 'Devolucion a traves de una cuenta de ahorros de Efectiva')
        {
            setInputs(prev => ({
                ...prev,
                nroCuenta: ''
            }));
        }
    }, [inputs.medioDevo]);
    //(@#)1-A Fin

    // logica para cargar los creditos
    useEffect(() => {
        //(@#)1-A Inicio
        resetearSegurosYRelacionados();

        setInputs(prev => ({
            ...prev,
            //(@#)2-A inicio
            motivoSol: '', 
            detalleMotivoSol: '', 
            prestamo: '',
            //(@#)2-A fin
            nroCuenta: ''
        }));
        //(@#)1-A Fin

        if (!inputs.tipoDocTit || !inputs.numDocTit || inputs.numDocTit.length < 8) return;

            const req = FinancieraAPI.getPrestamosReq(inputs.tipoDocTit, inputs.numDocTit);
            (async () => {
                try {
                    const res = await req.response;
                    // Validar si llegaron datos o si el cliente no existe
                    if (!res?.data || res.data.length === 0) {
                        setCreditos([]); // limpiar créditos
                        setResult({
                            procesing: false,
                            response: { isok: false, mensaje: 'Cliente no cuenta con credito(s) vigentes' }
                        });
                        return;
                    }
                    setCreditos(Array.isArray(res.data) ? res.data : []);
                } catch (err) {
                    setCreditos([]); // asegurar limpieza
                    setResult({ procesing: false, response: { isok: false, mensaje: Messages.PrestamoError } });
                }
            })();
            return req.cancel;
        
    }, [inputs.numDocTit]);

    //(@#)1-A inicio
    // logica para los medios de respuesta
    useEffect(() => {
        const req = FinancieraAPI.getMediosRespuestaReq();
        (async () => {
            try {
                const res = await req.response;
                setRespuesta(Array.isArray(res.data) ? res.data : []);
            } catch (err) {
                setResult({ procesing: false, response: { isok: false, mensaje: Messages.RespuestaError } });
            }
        })();
        return req.cancel;
    }, []);

    // logica para cargar los medios devolucion
    useEffect(() => {
        setInputs(prev => ({
            ...prev,
            medioDevo: ''
        }));

        setMediosDevo([]); // limpiar medios dev. anteriores

        if (!inputs.prestamo) return;

        const req = FinancieraAPI.getMedioDevolReq(inputs.prestamo);
        (async () => {
            try {
                const res = await req.response;
                setMediosDevo(Array.isArray(res.data) ? res.data : []);
            } catch (err) {
                setMediosDevo([]); // limpiar meidos
                setResult({ procesing: false, response: { isok: false, mensaje: Messages.MediosError } });
            }
        })();
        return req.cancel;

    }, [inputs.prestamo]);
    //(@#)1-A fin

    // logica para cargar los seguros
    useEffect(() => {    
        //(@#)1-A Inicio
        if (tipoSolCambiadoRef.current) {
            tipoSolCambiadoRef.current = false; // Resetea la bandera
            return;
        }   
        //(@#)1-A fin
        setInputs(prev => ({
            ...prev,
            seguro: '',
            cobertura: ''
        }));

        if (!inputs.prestamo || !inputs.tipoSol) return; 

        const req = FinancieraAPI.getSegurosReq(inputs.prestamo,inputs.tipoSol);
        (async () => {
            try {
                const res = await req.response;
                // Validar si llegaron datos o si el cliente no existe
                if (!res?.data || res.data.length === 0) {
                    setSeguros([]); // limpiar seguros
                    setResult({
                        procesing: false,
                        response: { isok: false, mensaje: 'Cliente no cuenta con seguro(s) asociados al credito segun el tipo de solicitud' }
                    });
                    return;
                }
                setSeguros(Array.isArray(res.data) ? res.data : []);
            } catch (err) {
                setSeguros([]); // limpiar seguros
                setResult({ procesing: false, response: { isok: false, mensaje: Messages.SegurosError } });
            }
        })();
        return req.cancel;

    }, [inputs.prestamo,inputs.tipoSol]);

    // logica para cargar las coberturas
    useEffect(() => {
        setCoberturas([]); // limpiar coberturas anteriores
        setCoberturasCargadas(false); // reiniciar bandera

        if (!inputs.seguro) return;

        if (inputs.tipoSol === 'Aplicacion de siniestros') {
            const req = FinancieraAPI.getCorbeturasReq(inputs.seguro);
            (async () => {
                try {
                    const res = await req.response;
                    setCoberturas(Array.isArray(res.data) ? res.data : []);
                } catch (err) {
                    setResult({ procesing: false, response: { isok: false, mensaje: Messages.CoberturasError } });
                } finally {
                    setCoberturasCargadas(true); // indicar que terminó de cargar
                }
            })();
            return req.cancel;
        }     
    }, [inputs.seguro]);

    // logica para combo departamentos
    useEffect(() => {
        const req = FinancieraAPI.getDepartamentosSQL();
        (async () => {
            try {
                const res = await req.response;
                setDepartamentos(Array.isArray(res.data) ? res.data : []);
            } catch (err) {
                setResult({ procesing: false, response: { isok: false, mensaje: Messages.DepartamentoError } });
            }
        })();
        return req.cancel;
    }, []);

    // logica para combo provincias
    useEffect(() => {
        setInputs(prev => ({
            ...prev,
            provincia: ''
        }));

        if (inputs.departamento === '') setProvincias([]);
        else {
            const req = FinancieraAPI.getProvinciasSQL(inputs.departamento);
            (async () => {
                try {
                    const res = await req.response;
                    setProvincias(Array.isArray(res.data) ? res.data : []);
                } catch (err) {
                    setResult({ procesing: false, response: { isok: false, mensaje: Messages.ProvinciaError } });
                }
            })();
            return req.cancel;
        } 
    }, [inputs.departamento]);

    // logica para combo distritos
    useEffect(() => {
        setInputs(prev => ({
            ...prev,
            distrito: ''
        }));

        if (inputs.provincia === '') setDistritos([]);
        else {
            const req = FinancieraAPI.getDistritosSQL(inputs.departamento, inputs.provincia);
            (async () => {
                try {
                    const res = await req.response;
                    setDistritos(Array.isArray(res.data) ? res.data : []);
                } catch (err) {
                    setResult({ procesing: false, response: { isok: false, mensaje: Messages.DistritoError } });
                }
            })();
            return req.cancel;
        }
    }, [inputs.provincia]);


    // logica para registrar reclamo
    const handleSend = async () => {
        if (result.procesing) return;

        // Crear el objeto con los seguros seleccionados
        const updatedInputs = {
            ...inputs,
            segurosSeleccionados // Añadir los seguros seleccionados al objeto
        };        
        
        setResult({procesing: true, response: null});
        setErrors(Helpers.asignarErrores(updatedInputs));

      
        const f = new FormData();
        if (archivos.length > 0) {
            for (let index = 0; index < archivos.length; index++) {
                f.append("myfiles", archivos[index]);  //Parametro del api
            }
        }

        // Adjuntar datos del formulario como JSON (convertido a string)
        f.append("data", JSON.stringify(updatedInputs)); // nombre "data" debe ser reconocido por backend
     
        try {
            const res = await FinancieraAPI.postRegistrarReclamoReq(f).response;
            
            setErrors(Helpers.asignarErrores(updatedInputs, res.data.validaciones));
            setResult({ procesing: true, response: res.data });
        } catch (err) {
            setResult({procesing: true, response: {isok: false, mensaje: Messages.RegistroError}});
        }
    };

    //(@#)1-A Inicio
    const resetearSegurosYRelacionados = () => {
        setSegurosSeleccionados([]);
        setSeguros([]);
        setCoberturas([]);
        setMediosDevo([]);
    };
    //(@#)1-A Fin

    // controlar cierre de modal
    function handleCloseModal () {
        if (result.response) if (result.response.isok) {
            setInputs(defaultInputs);
            setErrors(defaultErrors);
            setSegurosSeleccionados([]);
            setArchivos([]);
            setSeguros([]);
            setCoberturas([]);
            setCreditos([]);
            setMediosDevo([]); //(@#)1-A
            //(@#)2-A inicio
            setCoberturasCargadas(false);
            setMotivos([]); 
            setLocales([]);
            //(@#)2-A fin
        }
        setResult({procesing:false, response:null});
    };

    // agrupar data de combos
    const combos = { documentos, solicitudes, creditos, seguros, mediosDevo, respuesta, coberturas, departamentos, provincias, distritos, motivos, locales }; //(@#)2-A
    //const combos = { documentos, solicitudes, creditos, seguros, mediosDevo, respuesta, coberturas, departamentos, provincias, distritos }; //(@#)1-A //(@#)2-A
    //const combos = { documentos, solicitudes, creditos, seguros, coberturas, departamentos, provincias, distritos }; //(@#)1-A

    // retornar datos
    //return { inputs, names, handleChange, handleBlur, handleSeguroChange, handleCoberturaChange, handleEliminarSeguro, segurosSeleccionados, combos, handleSend, result, errors, handleCloseModal, archivos, subirArchivos };  //(@#)2-A
    return { inputs, names, handleChange, handleBlur, handleSeguroChange, handleCoberturaChange, handleEliminarSeguro, segurosSeleccionados, combos, handleSend, result, errors, handleCloseModal, archivos, subirArchivos, eliminarArchivo };   //(@#)2-A
};

export default useFinancieraLogic;